import { Component, EventEmitter, Input, Output } from '@angular/core';
import { sizeType } from '../../interfaces/enumSizeType';


@Component({
    selector: 'rr-badge',
    standalone: false,

    templateUrl: './badge.component.html',
    styleUrl: './badge.component.scss'
})
export class BadgeComponent {
    @Input() size: string | undefined = sizeType.Small;
    @Input() tone: string | undefined = "neutral";
    @Input() icon: string | undefined;
    @Input() type: string | undefined;

    @Output() click: EventEmitter<any> = new EventEmitter();
}
